<template>
  <section>
    <div class="page">
      <div>
        <h2>Generating a QR code</h2>
        <h3>
          To generate your account QR code
        </h3>
        <ol>
          <li>Go to <strong>Me</strong> tab.</li>
          <li>Tap <strong>QR Code</strong> icon at the top right.</li>
        </ol>
        <h3>
          To generate a group QR code
        </h3>
        <ol>
          <li>Go to the group in ToTok, then tap the group name at the top.</li>
          <li>Tap <strong>Group QR Code</strong>.</li>
        </ol>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
